import { render } from "./team-absences.vue?vue&type=template&id=657f593a&scoped=true&ts=true"
import script from "./team-absences.vue?vue&type=script&lang=ts"
export * from "./team-absences.vue?vue&type=script&lang=ts"

import "./team-absences.vue?vue&type=style&index=0&id=657f593a&lang=scss&scoped=true"

import exportComponent from "/app/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-657f593a"]])

export default __exports__